import { Box, Button, IconButton, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { updateSeed } from "../../slices/nftSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useTranslation } from "react-i18next";
import StarsIcon from '@mui/icons-material/Stars';
import SwapCallsIcon from '@mui/icons-material/SwapCalls';

export default function NftComposer(props) {

  const dispatch = useDispatch()
  const nftSlice = useSelector(state => state.nft)
  const { t } = useTranslation()

  const [imageIsHidden, setImageIsHidden] = useState(false);

  useEffect(() => {
    const seedFromQuery = new URLSearchParams(window.location.search).get("seed")
    if (seedFromQuery) {
      dispatch(updateSeed(seedFromQuery))
    } else {
      if (!nftSlice.seed) {

        dispatch(updateSeed())
      }
    }
    //after remove the seed from the query
    window.history.replaceState({}, document.title, window.location.pathname);
  }, [dispatch, nftSlice.seed]);

  useEffect(() => {

    // Quando assetsList cambia, resettiamo imageIsHidden a false
    setImageIsHidden(true);

    // Creiamo una lista di Promise per verificare il caricamento di tutte le immagini
    const imageLoadPromises = nftSlice.assetsList.map((src) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
        img.onerror = resolve; // gestisce il caso in cui l'immagine non possa essere caricata
      });
    });

    // Quando tutte le immagini sono caricate, aggiorniamo imageIsHidden a true
    Promise.all(imageLoadPromises).then(() => {
      setImageIsHidden(false);
    });
  }, [nftSlice.assetsList]);

  const theme = useTheme();

  const handleChangeSeed = (indexs, value) => {
    //lvl bg (0-1)  skin (2-3)  mouth (4) eye (5-6) mouth(7-8) chestSupported (9) chest (10) neck (11-12) head (13-14) gloveSupported (15 )gloves (16)
    let tempSeed = structuredClone(nftSlice.seed).toString().split('');
    let tempNewValue = "";
    indexs.forEach(index => {
      tempNewValue += tempSeed[index];
    });
    tempNewValue = parseInt(tempNewValue) + value;
    if (tempNewValue < 0) {
      tempNewValue = 99;
    }
    tempNewValue = "00" + tempNewValue;
    tempNewValue = tempNewValue.slice(-indexs.length);
    indexs.forEach((index, i) => {
      tempSeed[index] = tempNewValue[i];
      if (index === 16) {
        tempSeed[15] = 1;
      }
    });
    //rejoin the seed
    tempSeed = tempSeed.join('');
    setImageIsHidden(true);
    setTimeout(() => {
      dispatch(updateSeed(tempSeed));
    }, 500);
  }

  const changeIndexOnSeed = (index, value) => {
    let tempSeed = structuredClone(nftSlice.seed).toString().split('');
    tempSeed[index] = value.toString();
    tempSeed = tempSeed.join('');
    setImageIsHidden(true);
    setTimeout(() => {
      dispatch(updateSeed(tempSeed));
    }, 500);
  }

  const handleRandomize = () => {
    setImageIsHidden(true);

    setTimeout(() => {
      dispatch(updateSeed())
    }, 500);
    // setTimeout(() => {
    //   setImageIsHidden(false);
    // }, 1500);
  }

  return (
    <Box sx={{
      maxWidth: "100%",
    }}>
      <Grid container sx={{
        height: `100%`,
        maxWidth: "100%",
        gap: 3,
      }}>
        <Grid size={{
          xs: 12,
        }}
        >
          <Typography sx={{
            ml: "24px",
            mb: 2,
            [theme.breakpoints.down('md')]: {
              ml: "8px",
              fontSize: "15vw",
            },
            fontSize: "10vw",
            fontWeight: "bold",
            lineHeight: "1",
          }}
          >{t("label_try_it")}
          </Typography>
        </Grid>

        <Grid size={{
          xs: 10,
          lg: 6,
          xl: 5,
        }}
          offset={{
            xs: 1,
            xl: 2,
          }}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // minHeight: `100svh`,
            flexDirection: "column",

          }}>
          <Box sx={{
            width: "90svh",
            maxWidth: "100%",
            borderRadius: "40px",
            aspectRatio: 1,
            position: "relative",
            overflow: "hidden",
            "&::before": {
              content: "''",
              zIndex: 1000,
              background: "radial-gradient(circle,#aaff00 0%, #5500ff 100%)",
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              mask: `url('data:image/svg+xml;utf8,<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="50" /></svg>')
               center/contain no-repeat, linear-gradient(#000 0 0)`,
              maskComposite: "exclude",
              transition: "mask-size 0.5s",
              maskSize: imageIsHidden ? "0.01%" : "150%"
            },
            img: {
              width: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              selectable: "none",
            }
          }}>
            {
              nftSlice.assetsList.map((asset, index) => {
                if (asset) {
                  return <img key={asset + index} src={process.env.PUBLIC_URL + `/assets/nft/` + asset} alt="body" />
                } else {
                  return null
                }
              })
            }

          </Box>
          <Typography variant="h3" sx={{display: "none"}}>{nftSlice.seed}</Typography>
        </Grid>

        <Grid size={{
          xs: 12,
          lg: 4,
        }}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
            "& .selectionBox": {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              padding: "10px",
            },
            [theme.breakpoints.down('md')]: {
              "& .selectionBox": {
                display: "none",
              }
            }
          }}
        >
          <Button variant="contained" color="secondary" onClick={() => handleRandomize()} endIcon={<SwapCallsIcon />}
            disableElevation
            size="large"
            sx={{
              // color: "white !important",
              fontSize: "3vw",
              borderRadius: "100px",
              p: "5% 10%",
              mb: 2,
              "& svg":{
                fontSize: "3vw !important",
              },
               [theme.breakpoints.down('lg')]: {
                fontSize: "7vw",
                p: "5% 10%",
                borderRadius: "100px",
                "& svg":{
                fontSize: "7vw !important",
              },
               }
            }}>RANDOMIZE</Button>
          {/* BACKGROUND */}
          <Box className="selectionBox">
            <IconButton onClick={() => { handleChangeSeed([0, 1], -1) }}>
              <ArrowBackIosNewIcon />
            </IconButton>
            <Typography variant="h4">
              {t("label_nft_bg")}
            </Typography>
            <IconButton onClick={() => { handleChangeSeed([0, 1], 1) }}>
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>
          {/* PELLE */}
          <Box className="selectionBox">
            <IconButton onClick={() => { handleChangeSeed([2, 3], -1) }} >
              <ArrowBackIosNewIcon />
            </IconButton>
            <Typography variant="h4">
              {t("label_nft_skin")}
            </Typography>
            <IconButton onClick={() => { handleChangeSeed([2, 3], 1) }} >
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>

          {/* OCCHI */}
          <Box className="selectionBox">
            <IconButton onClick={() => { handleChangeSeed([5, 6], -1) }} >
              <ArrowBackIosNewIcon />
            </IconButton>
            <Typography variant="h4">
              {t("label_nft_eyes")}
            </Typography>
            <IconButton onClick={() => { handleChangeSeed([5, 6], 1) }} >
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>
          {/* BOCCA */}
          <Box className="selectionBox">
            <IconButton onClick={() => { handleChangeSeed([7, 8], -1) }} >
              <ArrowBackIosNewIcon />
            </IconButton>
            <Box sx={{
              display: "flex",
              gap: 1,
              alignItems: "center",
              justifyContent: "center",
            }}>
              <Typography variant="h4">
                {t("label_nft_mouth")}
              </Typography>
              <IconButton disabled={!nftSlice.supportMouthOpen} onClick={() => { changeIndexOnSeed(4, 1 - (nftSlice.mouth % 2)) }}>
                <StarsIcon />
              </IconButton>
            </Box>
            <IconButton onClick={() => { handleChangeSeed([7, 8], 1) }} >
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>
          {/* HEAD */}
          <Box className="selectionBox">
            <IconButton onClick={() => { handleChangeSeed([13, 14], -1) }} >
              <ArrowBackIosNewIcon />
            </IconButton>
            <Typography variant="h4">
              {t("label_nft_head")}
            </Typography>
            <IconButton onClick={() => { handleChangeSeed([13, 14], 1) }} >
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>
          {/* CHEST */}
          <Box className="selectionBox">
            <IconButton onClick={() => {
              if (!nftSlice.supportChest) {
                changeIndexOnSeed(9, 1);
              }
              handleChangeSeed([10], -1)
            }}>
              <ArrowBackIosNewIcon />
            </IconButton>
            <Typography variant="h4">
              {t("label_nft_chest")}
            </Typography>
            <IconButton onClick={() => {
              if (!nftSlice.supportChest) {
                changeIndexOnSeed(9, 1);
              }
              handleChangeSeed([10], 1)
            }}>
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>
          <Box className="selectionBox">
            <IconButton onClick={() => {
              if (!nftSlice.supportedGloves) {
                changeIndexOnSeed(15, 1);
              }
              handleChangeSeed([16], -1);
            }} >
              <ArrowBackIosNewIcon />
            </IconButton>
            <Typography variant="h4">
              {t("label_nft_gloves")}
            </Typography>
            <IconButton onClick={() => {
              if (!nftSlice.supportedGloves) {
                changeIndexOnSeed(15, 1);
              }
              handleChangeSeed([16], 1);
            }} >
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>
          <Box className="selectionBox">
            <IconButton onClick={() => {
              handleChangeSeed([11, 12], -1)
            }} >
              <ArrowBackIosNewIcon />
            </IconButton>
            <Typography variant="h4">
              {t("label_nft_neck")}
            </Typography>
            <IconButton onClick={() => {
              handleChangeSeed([11, 12], 1)
            }} >
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>
        </Grid>

      </Grid>

    </Box>
  )
}
